module.exports =
    typeof navigator !== 'undefined'
        ? navigator.userAgent.search(/ipad|ipod|iphone/i) !== -1
        : false;
